import { ref, type Ref } from 'vue';
import { CheckoutHelperObject } from '@/modules/billing/models/CheckoutHelperObject';
import { CheckoutPageAttributesObject } from '@/modules/billing/models/CheckoutPageAttributesObject';

export const checkoutPageAttributes: Ref<CheckoutPageAttributesObject | undefined> = ref(undefined);
export const checkoutHelper: Ref<CheckoutHelperObject> = ref(
  CheckoutHelperObject.mapModel(undefined)
);
